import React from 'react'
import { useMobileContext } from '../../Context/ContextProvider'
import MultiLoggerGraphV2 from './MultiLoggerGraphV2'
import MultiLoggerGraphMobile from './MultiLoggerGraphMobile'

interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            groupId: number | null;
            loggers: Array<number>;
            showBackButton: boolean;
            site: number | null;
        }
    }
    startDateProps: Date;
    endDateProps: Date;
    showDates: boolean;
    ref: React.RefObject<unknown>;
    fullscreen: boolean
    handleDateUpdate: (startDate: Date, endDate: Date) => void | null
}

const MultiLoggerGraphWrapper:React.FC<Props> = (props) => {
    const isMobile = useMobileContext()
    return isMobile ? <MultiLoggerGraphMobile {...props} />: <MultiLoggerGraphV2 {...props } />
}
export default MultiLoggerGraphWrapper